import { redirect } from "@tanstack/react-router";
import { authClient } from "./auth-client";

export async function requireAuth() {
  const session = await authClient.getSession();
  if (!session.data) throw redirect({ to: "/login" });
  return session.data;
}

function userHasRole(user: { roles?: string[]; role: string }, ...check: string[]): boolean {
  const roles = [...(user.roles ?? []), user.role];
  return check.some((r) => roles.includes(r));
}

export async function requireAdmin() {
  const session = await requireAuth();
  if (!userHasRole(session.user, "admin")) throw redirect({ to: "/dashboard" });
  return session;
}

export async function requireComplianceManager() {
  const session = await requireAuth();
  if (!userHasRole(session.user, "admin", "compliance_manager"))
    throw redirect({ to: "/dashboard" });
  return session;
}

export async function requireAuditAccess() {
  const session = await requireAuth();
  if (!userHasRole(session.user, "admin", "compliance_manager", "compliance_auditor"))
    throw redirect({ to: "/dashboard" });
  return session;
}

export async function requireTechPartner() {
  const session = await requireAuth();
  if (!userHasRole(session.user, "tech_partner")) throw redirect({ to: "/dashboard" });
  return session;
}

// Read-only audit pages: audit staff plus Tech Partners (the server limits a
// Tech Partner to audits on their own projects).
export async function requireAuditViewAccess() {
  const session = await requireAuth();
  if (
    !userHasRole(session.user, "admin", "compliance_manager", "compliance_auditor", "tech_partner")
  )
    throw redirect({ to: "/dashboard" });
  return session;
}
